import media from '../../../../../constants/media';
import { Columns } from '../../../../base/grid';
import { P, paragraphStyles } from '../../../../base/typography';
import styled, { css } from 'styled-components';

export const Wrapper = styled.div``;

export const FieldColumns = styled(Columns)``;

export const ButtonWrapper = styled.div`
	margin-top: 6rem;
	text-align: right;

	${media.mobileOnly`
		button {
			width: 100%;
		}
	`};
`;

export const WarningMessage = styled.div`
	color: ${({ theme }) => theme.colors.yellow};
	font-size: 1.4rem;
	margin: 0.5rem;
`;

export const BusinessAccountWarning = styled.div`
	color: ${({ theme }) => theme.colors.primary};
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	font-size: 1.4rem;
	margin: -1rem 0 2rem;

	a {
		color: inherit;
		text-decoration: underline;
	}
`;

export const SenderBusinessAccountWarning = styled(BusinessAccountWarning)`
	margin: 0.5rem 0 0;
`;

export const MarginDiv = styled.div`
	margin-bottom: 2rem;
`;

export const RedP = styled(P)`
	color: ${({ theme }) => theme.colors.primary};
`;

export const Pdiv = styled.div`
	${paragraphStyles};
	margin-top: ${({ marginTop }) => marginTop || '0'};

	${({ white, theme }) =>
		white &&
		css`
			color: ${theme.colors.white};
		`}

	${({ black, theme }) =>
		black &&
		css`
			color: ${theme.colors.black};
		`}

	${({ subtitle, theme }) =>
		subtitle &&
		css`
			font-size: 2rem;
			line-height: 3rem;
			color: ${theme.colors.grayDarker};
		`}

	${({ small }) =>
		small &&
		css`
			font-size: 1.6rem;
			line-height: 2.6rem;
		`}
`;
